// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"74ee7b07","879":"6947f557"}[chunkId] + ".chunk.js";
};